﻿import debounce from 'lodash.debounce'
import isInView from 'is-in-view'
import pageVisibility from 'visibilityjs'

let BACKGROUND_VISIBILITY_SCROLL_EVENT = null 

/** Class for handling background media of a DOM element, can be a: video or image */
export class BackgroundMedia {

  constructor (element) {
    this.element = element
    element.BackgroundMedia = this
    this.video = element.querySelector('video')
    this.image = element.querySelector('img')
    if (this.video) {
      this.addVideoEventListeners()
      this.toggleVideoPlayInView()
    }
  }

  /** toggles the state of background media */
  togglePlay (state) {
    state ? this.video.paused && this.video.play() : !this.video.paused && this.video.pause()
  }

  /** checks if the current instance of the background media is withing the viewport and toggles the play state based on that */
  toggleVideoPlayInView () {
    window.requestAnimationFrame(() => this.togglePlay(isInView(this.element)))
  }

  addVideoEventListeners () {
    this.video.addEventListener('playing', () => this.video.classList.add('is-loaded'), { once: true })
    // functionality to pause videwo when the background video is out of view in some way
    if (!BACKGROUND_VISIBILITY_SCROLL_EVENT) {
      const debouncedVideoToggling = debounce(() => {
        document.querySelectorAll('.background-media')
          .forEach(element => {
            if (element.BackgroundMedia && element.BackgroundMedia.video) {
              element.BackgroundMedia.toggleVideoPlayInView()
            }
          })
      }, 100)
      // pauses video when it is not in view; eg. the user is focused on another tab
      pageVisibility.change((event, state) => {
        document.querySelectorAll('.background-media').forEach(element => {
          if (element.BackgroundMedia && element.BackgroundMedia.video) {
            element.BackgroundMedia.togglePlay(state !== 'hidden')
          }
        })
      })
      // checks whether or not the background media is in view on scroll
      BACKGROUND_VISIBILITY_SCROLL_EVENT = window.addEventListener('scroll', debouncedVideoToggling, { passive: true })
    }
  }
}
